<template>
  <ModalLayout icon="delete" title="Delete screenshot?" @close="close">
    Are you sure you want to delete <strong>{{ meta?.screenshot?.name }}</strong>? This action cannot be undone.
    <template slot="footer">
      <el-button class="font-semibold" @click="close">{{ $t('cancel') }}</el-button>
      <el-button class="font-semibold ml-0" @click="ctaDelete" :loading="loading" icon="el-icon-delete"
        type="danger">Delete</el-button>
    </template>
  </ModalLayout>
</template>
<script>
import ModalLayout from '../ModalLayout.vue'
export default {
  name: 'DeleteScreenshot',
  components: { ModalLayout },
  props: {
    meta: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    async ctaDelete() {
      this.loading = true
      await this.$store.dispatch('socialBoostCampaign/deleteScreenshot', {
        id: this.$route.params.id,
        screenshot_id: this.meta.screenshot.id,
        flight_id: this.$route.params.flight_id
      })
      if (this.meta.redirectTo) {
        this.$router.push(this.meta.redirectTo)
      }
      this.$Modal.parent.init()
      this.close()
      this.loading = false
    },
  },
}
</script>
